module.exports = __webpack_public_path__ + "static/sound-8b8ece8b4cb8d3a287a21783f95f6995.jpg";